export default {
  data() {
    return {
      blogWhatsappLink: '',
      whatsappUrl: 'https://api.whatsapp.com/send/?phone=85237051599&text=',
    }
  },
  mounted() {
  },
  computed: {
  },
  methods: {
    generateWhatsappMsgLink(templateMsg, link) {
      if (!templateMsg) {
        return link
      }
      const msg = this.composeWhatsappMsg(templateMsg)
      return `${this.whatsappUrl}${encodeURIComponent(msg)}`;
    },
    composeWhatsappMsg(whatsappMsg) {
      let msg = whatsappMsg || '';
      let blogUrl = '';
      if (process.client) {
        blogUrl = window.location.toString().split('?')[0];

        if (blogUrl) {
          msg = msg?.replace('{blog_url}', blogUrl)
        } else {
          try {
            msg = msg?.replace('[ {blog_url} ]', '')
            throw new Error("*** blogUrl not valid ***");
          } catch (e) {
            console.error(e.name + ": " + e.message);
            this.$sentry && this.$sentry.captureException(e);
          }
        }
        const firstBlogCategoryDisplayName = this.getBlogFirstTag();
        if (firstBlogCategoryDisplayName) {
          msg = msg?.replace('{first_blog_category_display_name}', firstBlogCategoryDisplayName);
        } else {
          try {
            msg = msg?.replace('{first_blog_category_display_name}', '');
            throw new Error("*** firstBlogCategoryDisplayName not valid ***");
          } catch (e) {
            console.error(e.name + ": " + e.message);
            this.$sentry && this.$sentry.captureException(e);
          }
        }
      }
      return msg
    },
    getBlogFirstTag() {
      if (process.client) {
        const tag = document.querySelector('.blog-single .tags .tag');
        return tag?.innerText || '';
      }
      return '';
    },
  }
}
